<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-danger">
            <p class="modal-card-title">{{$t('MODALVINCULARINSIDEVENDA.AVISO')}}</p>
        </header>
        <section class="modal-card-body is-paddingless">
            <div class="panel">

                <p class="panel-block">
                    <searchIdName  :id.sync="guiaId"  :fullWidth="true"
                        :trazDesativado="false" :label="$t('MODALVINCULARINSIDEVENDA.PROJETO')" table="VendaInside" :camposAdicionais="'&unidadeId='+unidadeId" >                                           
                    </searchIdName>                                                                                     
                </p>    
                <br>
                <br>
                <br>
                <br>
                <br>
            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                     :loading="salvandoDados"
                      @click="confirmar">{{$t('SISTEMA.CONFIRMAR')}}</b-button>
            <b-button @click=" $emit('close'); ">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapState } from 'vuex'
    import searchIdName from '@/components/searchIdName.vue'    
    
    export default {

        props: {
            id: Number
        },        

        data() {
            return {                                                            
                salvandoDados :false,                
                guiaId:null,

            }
        },
        components: {                     
            searchIdName            
        },          
        computed: {
            ...mapState([                                
                'unidadeId',                
            ]),  
        },        

        mounted() {
            return true;
        },
        methods: {


            async confirmar() {

                if(this.guiaId>0 ){
                    this.salvandoDados=true;
                    const params = [];         
                    
                    if (this.id) params.push(`id=${this.id}`);                          
                    if (this.guiaId) params.push(`guiaId=${this.guiaId}`);                          
                    try {                                                    
                        this.$http.get(`/api/venda/VincularInsideVenda?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {
                            this.salvandoDados=false;                            
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.$t("SISTEMA.SALVOSUCESSO"),
                                type: 'is-success'
                            });                              
                        }).finally(() => {                                                                                                                    
                            this.$emit('loadData')    
                            this.$emit('loadVinculos')                                        
                            this.$emit('close');                                                                
                        });                             
                        
                    } catch (e) {
                        this.salvandoDados=false;                        
                        console.error(e);
                    }
                }

            },
            

        }
    }
</script>